var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.696 9.985 19.3 2.38A1.209 1.209 0 1 0 17.59.67L9.986 8.275 2.38.67A1.209 1.209 0 1 0 .67 2.38l7.605 7.604-7.604 7.604a1.209 1.209 0 1 0 1.71 1.71l7.604-7.605 7.604 7.604a1.206 1.206 0 0 0 1.71 0 1.21 1.21 0 0 0 0-1.71z",
    opacity: 0.61
  })));
};
export default SvgClose;